import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { compose, withHandlers, withProps } from 'recompose';

import { getRoleIdType } from '../../../../auth/selectors';
import { addBarberDebitCard, addShopDebitCard } from '../../actions';

const mapStateToProps = state => ({
  shopOrBarber: getRoleIdType(state),
});

const mapDispatchToProps = dispatch => ({
  addDebitCard: bindActionCreators({
    shop: addShopDebitCard,
    barber: addBarberDebitCard,
  }, dispatch),
});

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withHandlers({
    save: props => data => props.addDebitCard[props.shopOrBarber.type](props.shopOrBarber.id, data),
  }),
  withProps(() => ({
    form: 'addDebitCard',
  })),
);
